module.exports = {
	"articleTitle1": "Regents to consider $122M renovations to Dental building ",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "Dental Building",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/administration/board-regents-first-fall-meeting-covers-bylaw-addition-building-renovations",
	"articleSnippet1": "Sep 12, 2016 ... The University of Michigan's Board of Regents will vote Thursday on a proposed \nrenovation and addition to the Edward Henry Kraus Building, ...",
	"articleSnippet2": "Sep 15, 2016 ... The board approved a $122 million renovation project to the W.K. Kellogg \nInstitute and Dental building. The repairs will cover 172,000 square ...",
	"totalMisc": 0,
	"articleTitle2": "Board of Regents first fall meeting covers bylaw addition, building ...",
	"address": "1011 University Ave, Ann Arbor, MI 48109",
	"images": [],
	"position": {
		"lat": 42.279099,
		"lng": -83.73639
	},
	"tips": [],
	"bathroomrating": [],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/dentalbuilding.json
// module id = 861
// module chunks = 0